import { render, staticRenderFns } from "./StudyQuestion.vue?vue&type=template&id=7d6a6c74&scoped=true"
import script from "./StudyQuestion.vue?vue&type=script&lang=js"
export * from "./StudyQuestion.vue?vue&type=script&lang=js"
import style0 from "./StudyQuestion.vue?vue&type=style&index=0&id=7d6a6c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6a6c74",
  null
  
)

export default component.exports